import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="footer" className="bg-black text-white mt-32">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-20 py-24 grid md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <h3 className="font-display text-5xl mb-5">rinova</h3>
        <p className="text-white/50 max-w-sm leading-relaxed text-sm">
          All-natural home textiles woven from 100% organic cotton and linen. Designed to be lived in.
        </p>
      </div>
      <div>
        <p className="util-link text-[11px] text-white/40 mb-5">Shop</p>
        <ul className="space-y-3 text-white/70 text-sm">
          <li><Link to="/shop/blankets" className="link-hover">Blankets</Link></li>
          <li><Link to="/shop/towels" className="link-hover">Towels</Link></li>
          <li><Link to="/shop/fragrance" className="link-hover">Fragrance</Link></li>
          <li><Link to="/shop/collections" className="link-hover">Collections</Link></li>
        </ul>
      </div>
      <div>
        <p className="util-link text-[11px] text-white/40 mb-5">Discover</p>
        <ul className="space-y-3 text-white/70 text-sm">
          <li><Link to="/material-science" className="link-hover">Material Profile</Link></li>
          <li><Link to="/news" className="link-hover">News</Link></li>
          <li><Link to="/shop" className="link-hover">All Products</Link></li>
          <li><Link to="/admin" className="link-hover">Admin</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-20 py-6 flex flex-col sm:flex-row justify-between gap-2 text-white/40 text-xs">
        <span>© {new Date().getFullYear()} rinova. All rights reserved.</span>
        <span className="util-link text-[11px]">Woven Natural · Zero Synthetic</span>
      </div>
    </div>
  </footer>
);
